<template>
  <div v-if="isVisible" class="modal-overlay" @click="$emit('close')">
    <div class="modal-content success-modal" @click.stop>
      <!-- Success Content -->
      <div class="success-content">
        <div class="success-icon">
          <i class="fas fa-check-circle"></i>
        </div>

        <h2 class="success-title">🎉 {{$t('promo_code_created')}}</h2>

        <p class="success-message">
          {{$t('promo_code_created_and_ready_to_use')}}
        </p>

        <div class="promotion-code-display">
          <div class="code-container">
            <span class="code-label">{{$t('promo_code')}}:</span>
            <div class="code-value">
              <span class="code-text">{{ promotionCode }}</span>
              <button
                class="copy-button"
                @click="copyToClipboard"
                :class="{ 'copied': isCopied }"
              >
                <img  v-if="!isCopied" src="../../assets/images/copyOutline.svg">
                <img  v-else src="../../assets/images/checkboxChecked.svg">
              </button>
            </div>
          </div>
        </div>

        <div class="success-actions">
          <button class="btn-secondary" @click="$emit('close')">
            {{ $t('close') }}
          </button>
          <button class="btn-primary" @click="$emit('view-codes')">
            {{$t('view_promo_codes')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromotionSuccessModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    promotionCode: {
      type: String,
      default: ''
    }
  },
  emits: ['close', 'view-codes'],
  data() {
    return {
      isCopied: false
    }
  },
  methods: {
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.promotionCode)
        this.isCopied = true

        setTimeout(() => {
          this.isCopied = false
        }, 2000)

        this.$snackbar?.add({
          type: 'success',
          text: this.$t('promo_code_copied')
        })
      } catch (err) {
        console.error('Kopyalama hatası:', err)
        this.$snackbar?.add({
          type: 'error',
          text: this.$t('copying_failed')
        })
      }
    }
  }
}
</script>

<style scoped>
/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}

.modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
}

.success-modal {
  width: 500px;
  padding: 0;
}

.success-content {
  padding: 40px;
  text-align: center;
}

.success-icon {
  margin-bottom: 20px;
}

.success-icon i {
  font-size: 64px;
  color: #10b981;
}

.success-title {
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 12px;
}

.success-message {
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 32px;
  line-height: 1.5;
}

.promotion-code-display {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
}

.code-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.code-label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.code-value {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  padding: 12px 16px;
}

.code-text {
  font-family: 'Courier New', monospace;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  letter-spacing: 2px;
}

.copy-button {
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6b7280;
}

.copy-button:hover {
  background: #e5e7eb;
  color: #374151;
}

.copy-button.copied {
  background: #10b981;
  border-color: #10b981;
  color: white;
}

.success-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.btn-primary, .btn-secondary {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  font-size: 14px;
}

.btn-primary {
  background: #3b82f6;
  color: white;
}

.btn-primary:hover {
  background: #2563eb;
}

.btn-secondary {
  background: white;
  color: #6b7280;
  border: 1px solid #d1d5db;
}

.btn-secondary:hover {
  background: #f9fafb;
  color: #374151;
}

/* Responsive */
@media (max-width: 576px) {
  .success-modal {
    width: 100%;
    margin: 20px;
  }

  .success-content {
    padding: 24px;
  }

  .success-actions {
    flex-direction: column;
  }

  .btn-primary, .btn-secondary {
    width: 100%;
  }
}
</style>
